/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'email-controller';
const prefix = `${moduleName}.${componentName}`;

export const columnTitleToAddress = `${prefix}.columnTitleToAddress`;
export const columnTitleCCAddress = `${prefix}.columnTitleCCAddress`;
export const columnTitleValidateSettings = `${prefix}.columnTitleValidateSettings`;
export const modalHeaderEdit = `${prefix}.modalHeaderEdit`;
export const modalHeaderNew = `${prefix}.modalHeaderNew`;
export const emailInformationHeader = `${prefix}.emailInformationHeader`;
export const toAddressInputLabel = `${prefix}.toAddressInputLabel`;
export const ccAddressInputLabel = `${prefix}.ccAddressInputLabel`;
export const emailExamplePlaceholder = `${prefix}.emailExamplePlaceholder`;
export const emailTitleLabel = `${prefix}.emailTitleLabel`;

export const ENGLISH = {
    [columnTitleToAddress]: 'To Address',
    [columnTitleCCAddress]: 'CC Address',
    [columnTitleValidateSettings]: 'Validate Settings',
    [modalHeaderEdit]: 'Edit Email Notification: {0}',
    [modalHeaderNew]: 'New Email Notification: {0}',
    [emailInformationHeader]: 'Email Information',
    [toAddressInputLabel]: 'To Address',
    [ccAddressInputLabel]: 'CC Address',
    [emailExamplePlaceholder]: 'ex. john@doe.com, jane@doe.com',
    [emailTitleLabel]: 'Validate Email Settings',
};
